import "./layout.less";
import "../styles/icons/style.less";
import "../styles/animations.less";
import "../components/block-elements/ui-checkbox/ui-checkbox.less";
import "../components/block-elements/ui-radio/ui-radio.less";
import "../components/block-elements/ui-input/ui-input.less";
import "../components/block-elements/ui-select/ui-select.less";
import "@parksandresorts/core/sommarland.css";
import { PropsWithChildren } from "react";
import { multipleClassNames, useNavbarStickyHeight } from "@parksandresorts/core";

const Layout = ({ children }: PropsWithChildren) => {
  const navbarStickyHeight = useNavbarStickyHeight();

  return (
    <div
      id="Layout"
      style={
        navbarStickyHeight
          ? ({ "--navbar-sticky-bottom-height": `${navbarStickyHeight}px` } as React.CSSProperties)
          : undefined
      }
      className={multipleClassNames(navbarStickyHeight > 0 ? "navbar-sticky-bottom" : undefined)}
    >
      {children}
    </div>
  );
};

export default Layout;
